import { selectSectionMetadataContext } from "./section-context";

import { t } from "i18n/i18n";
import { RootState } from "store/index";
import { sectionSelectors } from "store/selectors";

export const ORG_VIEW_EXPLANATION_CONTEXT = t("ai.org_view_explanation_long");

export const ORG_SECTION_STRUCTURE_EXPLANATION_CONTEXT = t("ai.org_section_structure_explanation");

export const selectSectionListContext = (state: RootState) => {
  const sectionIds = sectionSelectors.selectIds(state);
  const lines = sectionIds
    .map((sectionId) => selectSectionMetadataContext(state, sectionId))
    .join("\n");

  return t("ai.org_sections_available", { sections: lines });
};
